// extracted by mini-css-extract-plugin
export default {"callToAction":"index_callToAction__VAcmd"};